import { Component, Injectable, ViewChild, TemplateRef, ElementRef, OnInit, ViewEncapsulation, Input, Output, EventEmitter } from '@angular/core';
import { FlatTreeControl } from '@angular/cdk/tree';
import { CollectionViewer, SelectionChange } from '@angular/cdk/collections';
import { BehaviorSubject, Observable, merge, map } from 'rxjs';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { DatepickerDateCustomClasses } from 'ngx-bootstrap/datepicker';
import { MatSnackBar } from '@angular/material/snack-bar';
import { AppService } from 'src/app/app.service';
import { messageService } from 'src/app/message.service';
import { qmsService } from 'src/app/qms/qms.service';
import { PaginationService } from 'src/app/PaginationService';
import { local } from 'd3-selection';
import { SuccessSnackbarComponent } from 'src/app/support/success-snackbar/success-snackbar.component';



export class DynamicFlatNode {
  constructor(public folderId: number, public folderName: string, public parentFolderId: number,
    public folderPath: string, public path: string, public level = 1, public expandable = false,
    public isLoading = false,) { }
}

@Injectable()
export class DynamicDataSource {

  dataChange = new BehaviorSubject<DynamicFlatNode[]>([]);

  breadCrumb: any;
  get data(): DynamicFlatNode[] { return this.dataChange.value; }
  set data(value: DynamicFlatNode[]) {
    this._treeControl.dataNodes = value;
    this.dataChange.next(value);
  }

  constructor(private _treeControl: FlatTreeControl<DynamicFlatNode>, private appService: AppService, private folderComponent: FolderStuctureComponent, public snackBar: MatSnackBar) { }

  connect(collectionViewer: CollectionViewer): Observable<DynamicFlatNode[]> {
    this._treeControl.expansionModel.changed.subscribe(change => {
      if ((change as SelectionChange<DynamicFlatNode>).added ||
        (change as SelectionChange<DynamicFlatNode>).removed) {
        this.handleTreeControl(change as SelectionChange<DynamicFlatNode>);
      }
    });

    return merge(collectionViewer.viewChange, this.dataChange).pipe(map(() => this.data));
  }

  /** Handle expand/collapse behaviors */
  handleTreeControl(change: SelectionChange<DynamicFlatNode>) {
    if (change.added) {
      change.added.forEach(node => this.toggleNode(node, true));
    }
    if (change.removed) {
      change.removed.slice().reverse().forEach(node => this.toggleNode(node, false));
    }
  }

  /**
   * Toggle the node, remove from display list
   */
  toggleNode(node: DynamicFlatNode, expand: boolean) {

    const index = this.data.indexOf(node);
    if (!expand) {
      let count = 0;
      for (let i = index + 1; i < this.data.length
        && this.data[i].level > node.level; i++, count++) { }
      this.data.splice(index + 1, count);
      this.dataChange.next(this.data);
    }
    else {
      node.isLoading = true;
      let data = node.folderId;
      this.breadCrumb = node.path;
      let folderTypeForTree = this.appService.getFolderTypeForTree();
      let orgIdvals = this.appService.getOrgVal();
      if (folderTypeForTree == 'DISTRIBUTED' || folderTypeForTree == 'MOVEDOC') {
        this.appService.getFoldersForDistributedFolders(data).subscribe((data: any) => {
          if (!data || index < 0) { // If no children, or cannot find the node, no op
            node.isLoading = false;

            return;
          }
          if (expand) {
            const nodes = data.map((obj: any) =>
              new DynamicFlatNode(obj.folderId, obj.folderName, obj.parentFolderId, obj.folderPath, obj.folderNamePath, node.level + 1, true));
            this.data.splice(index + 1, 0, ...nodes);

          }
          node.isLoading = false;
          // notify the change
          this.dataChange.next(this.data);

        })
      } else if (folderTypeForTree == 'DOCTYPEADD') {
        let docType = this.appService.getDocumentTypeOfFolder();
        this.appService.getDmsFolderListByDocType(
          docType, data).subscribe((data: any) => {
            if (!data || index < 0) { // If no children, or cannot find the node, no op
              node.isLoading = false;

              return;
            }
            if (expand) {
              const nodes = data.map((obj: any) =>

                new DynamicFlatNode(obj.folderId, obj.folderName, obj.parentFolderId, obj.folderPath, obj.folderNamePath, node.level + 1, true));
              this.data.splice(index + 1, 0, ...nodes);
              console.log(this.data)
            }
            node.isLoading = false;
            // notify the change
            this.dataChange.next(this.data);

          })
      } else if (folderTypeForTree == 'GROUPFOLDER') {

        if (orgIdvals && orgIdvals != "") {
          this.appService.setOrgVal("");
          this.appService.getDmsFoldersVwDetails1(
            data).subscribe((data: any) => {
              if (!data || index < 0) { // If no children, or cannot find the node, no op
                node.isLoading = false;

                return;
              }
              if (expand) {
                const nodes = data.map((obj: any) =>
                  new DynamicFlatNode(obj.folderId, obj.folderName, obj.parentFolderId, obj.folderPath, obj.folderNamePath, node.level + 1, true));
                this.data.splice(index + 1, 0, ...nodes);

                console.log(this.data)
              }
              node.isLoading = false;
              // notify the change
              this.dataChange.next(this.data);

            });


        } else {
          this.appService.getDmsFoldersVwDetails1(
            data).subscribe((data: any) => {
              if (!data || index < 0) { // If no children, or cannot find the node, no op
                node.isLoading = false;
                return;
              }
              if (expand) {
                const nodes = data.map((obj: any) =>
                  new DynamicFlatNode(obj.folderId, obj.folderName, obj.parentFolderId, obj.folderPath, obj.folderNamePath, node.level + 1, true));
                this.data.splice(index + 1, 0, ...nodes);

                console.log(this.data)
              }
              node.isLoading = false;
              // notify the change
              this.dataChange.next(this.data);

            })
        }

      } else {
        this.appService.getDmsFolderList(data).subscribe((data: any) => {
          if (!data || index < 0) { // If no children, or cannot find the node, no op
            node.isLoading = false;

            return;
          }
          if (expand) {
            const nodes = data.map((obj: any) =>
              new DynamicFlatNode(obj.folderId, obj.folderName, obj.parentFolderId, obj.folderPath, obj.folderNamePath, node.level + 1, true));
            this.data.splice(index + 1, 0, ...nodes);
            console.log(this.data)
          }
          node.isLoading = false;
          // notify the change
          this.dataChange.next(this.data);

        })
      }



    }
  }


}

@Component({
  selector: 'app-folder-stucture',
  templateUrl: './folder-stucture.component.html',
  styleUrls: ['./folder-stucture.component.scss']
})
export class FolderStuctureComponent implements OnInit {

  @Input() data: any = {};
  @Input() type: any;
  @Output() valueChange = new EventEmitter<{ documentData: {} }>;
  treeControl: FlatTreeControl<DynamicFlatNode>;
  isProcessing: any = false;
  dataSource: any;
  searchValue = "";
  getLevel = (node: DynamicFlatNode) => node.level;

  expandable = (node: DynamicFlatNode) => node.expandable;

  hasChild = (_: number, _nodeData: DynamicFlatNode) => _nodeData.expandable;
  dateFormat: any = this.appService.organizationDetails?.dateFormat == null ? 'DD-MMM-YYYY' : this.appService.organizationDetails?.dateFormat;
  datePickerConfiguration = {
    dateInputFormat: this.dateFormat,
    showWeekNumbers: false,
    containerClass: 'theme-dark-blue',
    showTodayButton: false,
    todayPosition: 'center'
  }

  visibleConfirmWithReason: MatDialogRef<TemplateRef<any>>;
  @ViewChild('confirmWithReasonPopup', { static: true }) confirmWithReasonPopup: TemplateRef<any>;

  confirmWithReasonPopupConfig = {
    width: '500px',
    height: 'auto',
    panelClass: 'my-dialog',
    hasBackdrop: false,
    disableClose: true,
    position: { top: '10px' },
  };

  dateCustomClasses: DatepickerDateCustomClasses[];
  folderComponent: FolderStuctureComponent;

  constructor(public dialog: MatDialog, private appService: AppService, public paginationService: PaginationService,
    public qmsservice: qmsService, public message: messageService, public router: Router, private snackBar: MatSnackBar) {

  }

  ngOnChanges() {
    console.log(this.data, "=data");
    this.appService.setDocFolderTreeType(this.data);

  }
  folderpath: any = "Repository"
  ngOnInit(): void {
    this.message.taskLevelData = {
      subModuleName: ""
    }
    this.treeControl = new FlatTreeControl<DynamicFlatNode>(this.getLevel, this.expandable);
    this.dataSource = new DynamicDataSource(this.treeControl, this.appService, this.folderComponent, this.snackBar);
    let data: any = [];
    data.push("Repository");
    this.dataSource.data = data.map((name: any) => new DynamicFlatNode(0, name, 0, "", "", 0, true));

    const now = new Date();

    this.dateCustomClasses = [{ date: now, classes: ['bg-warning'] }];
  }
  showingRowsText = "Showing rows";
  perPage = 10;
  maxSize = 3;
  collectionSize: number;
  pager: any = {};
  pagedItems: any[];
  makeStickyColumns: any;
  breadCrumbList: any = [];

  parentCheckBox: boolean = false;
  childCheckBoxs: boolean = false;

  setPage(page: number, targetpage: number) {
    if (page < 1 || page > this.pager.totalPages) {
      return;
    }
    if (Number.isNaN(page)) {
      page = 1;
    }

    this.pager = this.paginationService.getPager(this.documentsList.length, page, this.perPage, targetpage);
    this.pagedItems = this.documentsList.slice(this.pager.startIndex, this.pager.endIndex + 1);
  }

  paginationCall(value: number) {
    this.perPage = value;
    this.setPage(this.pager.currentPage, 0);
  }

  dataGridParentCheckBoxChecked(e: any) {
    if (e.target.checked == true) {
      this.childCheckBoxs = true;

      // Determine the limit (max 10)
      let limit = this.documentsList.length;
      if (limit > 10) {
        limit = 10;
        this.showSnackBar("Only 10 documents are allowed for bulk download. The first 10 documents have been selected.", 'E');

      }

      this.checkedCount = 0; // Reset count before selecting

      for (let p = 0; p < this.documentsList.length; p++) {
        if (p < limit) {
          // Select the first 10
          this.documentsList[p].searchDocumentChildCheckBoxs = true;
          this.checkedCount++;

          if (this.data == "DISTRIBUTED") {
            this.valueChange.emit({ documentData: this.documentsList[p] });
          }
          if (this.data == 'DOCUMENTFORDOWNLOAD') {
            this.documentData = this.documentsList[p];
            this.documentData.isAdd = true;
            this.valueChange.emit({ documentData: this.documentData });
          }
        } else {
          // Ensure anything beyond 10 is explicitly unchecked
          this.documentsList[p].searchDocumentChildCheckBoxs = false;
          if (this.data == 'DOCUMENTFORDOWNLOAD') {
            this.documentData = this.documentsList[p];
            this.documentData.isAdd = false;
            this.valueChange.emit({ documentData: this.documentData });
          }
        }
      }
      this.parentCheckBox = (this.checkedCount === this.documentsList.length);
    } else {
      this.childCheckBoxs = false;
      this.checkedCount = 0;
      for (let p = 0; p < this.documentsList.length; p++) {
        this.documentsList[p].searchDocumentChildCheckBoxs = false;
        if (this.data == 'DOCUMENTFORDOWNLOAD') {
          this.documentData = this.documentsList[p];
          this.documentData.isAdd = false;
          this.valueChange.emit({ documentData: this.documentData });
        }
      }
      if (this.data == "DISTRIBUTED") {
        this.valueChange.emit({ documentData: {} });
      }

      this.parentCheckBox = false;
    }
  }
  documentData: any = {};
  previousCheckedData: any = {};
  checkedCount = 0;
  dataGridChildCheckBoxChecked(e: any, list: any, idx: any) {
    if (e.target.checked) {
      // Prevent selection if limit is reached
      if (this.checkedCount >= 10) {
        this.showSnackBar("You can only select a maximum of 10 documents.", 'E');
        e.target.checked = false; // Revert the DOM checkbox state
        list.searchDocumentChildCheckBoxs = false; // Keep model state false
        return;
      }

      list.searchDocumentChildCheckBoxs = true;
      this.checkedCount++; // Increment count correctly
      this.documentData = list;

      if (this.data == 'DOCUMENTFORDOWNLOAD') {
        this.documentData.isAdd = true;
      }

      this.valueChange.emit({ documentData: this.documentData });

      if (this.data != 'DISTRIBUTED' && this.data != 'DOCUMENTFORDOWNLOAD') {
        this.previousCheckedData.searchDocumentChildCheckBoxs = false;
      }

      if (this.checkedCount == this.documentsList.length) {
        this.parentCheckBox = true;
      }
    } else {
      this.checkedCount--; // FIXED: Changed from ++ to -- so deselection correctly reduces the count
      list.searchDocumentChildCheckBoxs = false;

      if (this.data == 'DOCUMENTFORDOWNLOAD') {
        this.documentData = list;
        this.documentData.isAdd = false;
      } else {
        this.documentData = {};
      }

      if (this.checkedCount != this.documentsList.length) {
        this.parentCheckBox = false;
      }
      this.valueChange.emit({ documentData: this.documentData });
    }
    this.previousCheckedData = list;
  }
  isShowDocGrid = false;
  onTypeChanged(data: any) {
    if (data == "All Documents") {
      this.documentData = {
        documentId: 0,
        folderId: this.clickedData.folderId,
        isFrom: "allDocuments"
      }
      this.isShowDocGrid = false;
      this.valueChange.emit({ documentData: this.documentData });
    } else {
      this.isShowDocGrid = true;
      this.documentData = {
        documentId: null,
        folderId: null,
        isFrom: "allDocuments"
      }
      this.valueChange.emit({ documentData: this.documentData });
    }
  }

  showSnackBar(message: string, type: string) {
    const sb = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
      duration: type === 'S' ? 5000 : undefined,
      data: {
        message,
        type: type === 'S' ? 'Success' : 'Warning !',
        buttonLabel: 'Ok',
        pageName: this.message.breadcrumbData.thirdLevel ?? this.message.breadcrumbData.secondLevel,
      },
      horizontalPosition: 'center',
      verticalPosition: 'top',
      panelClass: type === 'S' ? 'Success' : 'Error',
    });

    sb.onAction().subscribe(() => {
      sb.dismiss();
    });
  }

  showDocumentsGrid: boolean = false;
  documentsList: any = [];
  clickedData: any = {};
  status: any;
  activeNode: any;
  breadCrumb: any;
  isDocumentAllOrIndividual: any;
  openLeftSideGridFunc(data: any) {
    this.folderpath = "Repository>" + data.folderPath;
    this.clickedData = data;
    this.breadCrumb = data.path;
    this.documentsList = [];
    if (this.data == "DOCTYPEADD" || this.data == "GROUPFOLDER" || this.data == "MOVEDOC" || this.data == "DOCUMENTFORHOME") {
      if (data.folderName != "Repository") {
        this.activeNode = data;
        this.valueChange.emit({ documentData: data });
      }
    } else if (this.data == "DOCUMENT" || this.data == "DISTRIBUTED" || this.data == "DOCUMENTFORFORMSLOGS" || this.data == "DOCUMENTFORDOWNLOAD") {
      if (data.folderName != "Repository") {
        this.activeNode = data;
        this.documentsList = [];
        this.isShowDocGrid = false;
        if (this.data == "DOCUMENTFORFORMSLOGS") {
          this.isProcessing = true;
          this.appService.getDocumentsForFormsAndLogs(data.folderId)
            .subscribe((data: any) => {
              this.isProcessing = false;
              this.showDocumentsGrid = true;
              this.isShowDocGrid = true;
              this.documentsList = data;
              this.collectionSize = this.documentsList.length;
              this.pager.totalPages = undefined;
              this.setPage(1, 0);
            })
        } else if (this.data == "DOCUMENTFORDOWNLOAD") {
          this.checkedCount = 0;
          this.documentData = {
            documentId: null,
            folderId: null,
            isFrom: "allDocuments"
          }
          this.valueChange.emit({ documentData: this.documentData });
          this.isProcessing = true;
          this.appService.getDownloadPrivForFolder(this.clickedData.folderId)
            .subscribe((data: any) => {
              if (data != 0) {
                this.appService.getDocumentsForDownloadDoc(this.clickedData.folderId)
                  .subscribe((data: any) => {
                    this.isProcessing = false;
                    this.showDocumentsGrid = true;
                    this.isShowDocGrid = true;
                    this.documentsList = [];
                    for (let i = 0; i < data.length; i++) {
                      if (data[i].status == 'Published') {
                        data[i].folderName = this.clickedData.folderName;
                        this.documentsList.push(data[i]);
                      }
                    }
                    this.collectionSize = this.documentsList.length;
                    //console.log(this.documentTypeCall);
                    this.pager.totalPages = undefined;
                    this.setPage(1, 0);
                  })
              } else {
                this.isProcessing = false;
                this.documentsList = [];
                this.collectionSize = this.documentsList.length;
                //console.log(this.documentTypeCall);
                this.pager.totalPages = undefined;
                this.setPage(1, 0);
              }
            })

        } else {
          this.isProcessing = true;
          this.appService.getDocumentsForAssociatedDoc(data.folderId)
            .subscribe((data: any) => {
              this.isProcessing = false;
              this.showDocumentsGrid = true;
              if (this.type == true) {
                for (let i = 0; i < data.length; i++) {
                  if (data[i].status == 'Published') {
                    this.documentsList.push(data[i]);
                  }
                }

              } else {
                for (let i = 0; i < data.length; i++) {
                  if (data[i].status != 'Deleted') {
                    this.documentsList.push(data[i]);
                  }
                }
                //this.documentsList = data;
              }



              this.collectionSize = this.documentsList.length;
              //console.log(this.documentTypeCall);
              this.pager.totalPages = undefined;
              this.setPage(1, 0);
              if (this.data == "DOCUMENT" || this.data == "DOCUMENTFORFORMSLOGS") {
                this.isShowDocGrid = true;
              } else {
                this.isShowDocGrid = false;
                this.isDocumentAllOrIndividual = "All Documents"
                this.documentData = {
                  documentId: 0,
                  folderId: this.clickedData.folderId,
                  isFrom: "allDocuments"
                }
                this.valueChange.emit({ documentData: this.documentData });
              }
            })
        }

      }
    } else {
      if (data.folderName != "Repository") {
        this.activeNode = data;
        this.isProcessing = true;
        this.appService.getDocumentListForTraining( data.folderId)
          .subscribe((data: any) => {
            this.documentsList = data;
            this.isProcessing = false;
            this.showDocumentsGrid = true;
            this.collectionSize = this.documentsList.length;
            //console.log(this.documentTypeCall);
            this.pager.totalPages = undefined;
            this.setPage(1, 0);
          })
      }
    }
  }

  documentsListTemp: any = [];
  applyFilter2(event: Event) {
    const filter = (event.target as HTMLInputElement).value.trim().toLowerCase();
    if (filter === '') {
      this.documentsListTemp = this.documentsList;
      this.pager = this.paginationService.getPager(this.documentsListTemp.length, 1, this.perPage, 0);
      this.pagedItems = this.documentsListTemp.slice(this.pager.startIndex, this.pager.endIndex + 1);
    } else {
      /* this.oneQmsUsersDataForTable1temp = this.oneQmsUsersDataForTable1.filter((item: { subject: string; date: { toString: () => string | string[]; }; }) =>
        item.subject?.toLowerCase().includes(filter) ||
        item.date?.toString().includes(filter)
      ); */
      if (this.documentsList == undefined) {
        return this.documentsList;
      }
      if (!this.documentsList.length) {
        return this.documentsList;
      }
      if (filter != undefined) {
        this.documentsListTemp = this.documentsList.filter(function (item: any) {
          return JSON.stringify(item).toLowerCase().includes(filter);
        });
        //this.totalPages = Math.ceil(this.oneQmsUsersDataForTable1temp.length / this.itemsPerPage);
        //this.pager.totalPages=this.totalPages ;

      } else {
        this.documentsListTemp = this.documentsList.filter(function (item: any) {
          return JSON.stringify(item).toLowerCase();
        });
        //this.totalPages = Math.ceil(this.oneQmsUsersDataForTable1temp.length / this.itemsPerPage);
        //this.pager.totalPages=this.totalPages ;
      }
      this.collectionSize = this.documentsListTemp.length;
      this.setPagedorserch(1, 0);
    }
  }

  setPagedorserch(page: number, targetpage: number) {
    // if (page < 1 || page > this.pager.totalPages) {
    //   return;
    // }
    if (Number.isNaN(page)) {
      page = 1;
    }

    if (this.documentsListTemp.length > 0) {
      this.pager = this.paginationService.getPager(this.documentsListTemp.length, page, this.perPage, targetpage);
      this.pagedItems = this.documentsListTemp.slice(this.pager.startIndex, this.pager.endIndex + 1);
    } else {
      this.pagedItems = [];
    }
  }

}
